import { isRequired } from '@/utils/CustomErrors'
import { LOGIN_ERROR_STATE } from '@/config/constants'

const baseUrl = process.env.VUE_APP_SANITAS_PATH
const defaultHeaders = {
  Accept: ['application/json', 'text/plain', '*/*'],
  'X-Requested-With': 'XMLHttpRequest',
}

export const AuthHelper = {
  async createBasket({ payload = isRequired('payload') }) {
    const body = JSON.stringify(payload)
    const response = await fetch(`${baseUrl}/api/ovpv3/customer/baskets`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        ...defaultHeaders,
        ...{
          'Content-Type': 'application/json',
        },
      },
      body,
    })

    const resData = await response.json()
    return resData.data
  },

  async getBasketByCookie() {
    const response = await fetch(`${baseUrl}/api/ovpv3/customer/get-family`, {
      credentials: 'include',
      headers: defaultHeaders,
    })

    if (response.status !== 200) {
      throw new Error(LOGIN_ERROR_STATE.GENERAL)
    }

    const resData = await response.json()
    return resData.data
  },

  async signIn({ username = isRequired('username'), password = isRequired('password') }) {
    // 1. Logout
    const logoutRes = await AuthHelper.logout()
    if (logoutRes.status !== 200) {
      throw new Error(LOGIN_ERROR_STATE.GENERAL)
    }

    // 2. Init Login
    const initRes = await initLogin()
    if (initRes.status !== 200) {
      throw new Error(LOGIN_ERROR_STATE.GENERAL)
    }

    // 3. Actual login
    const loginRes = await login({ username, password })
    if (loginRes.status !== 200) {
      throw new Error(loginRes.status === 403 ? LOGIN_ERROR_STATE.INVALID_CREDENTIALS : LOGIN_ERROR_STATE.GENERAL)
    }
  },

  async logout() {
    const queryParams = new URLSearchParams({
      cmd: 'papilogout',
    })
    return await fetch(`${baseUrl}/login/sls/auth?${queryParams}`, {
      credentials: 'include',
      headers: defaultHeaders,
    })
  },

  async verifyToken({ twoFaToken = isRequired('twoFaToken') }) {
    const body = JSON.stringify({
      twoFaToken: twoFaToken,
    })
    const res = await fetch(`${baseUrl}/login/sls/verify2faToken`, {
      method: 'POST',
      credentials: 'include',
      headers: defaultHeaders,
      body,
    })

    if (res.status !== 200) {
      throw new Error(res.status === 403 ? LOGIN_ERROR_STATE.INVALID_CREDENTIALS : LOGIN_ERROR_STATE.GENERAL)
    }
  },
}

async function initLogin() {
  const queryParams = new URLSearchParams({
    RequestedPage: '/api/customer/index',
  })

  return await fetch(`${baseUrl}/login/sls/logininit?${queryParams}`, {
    credentials: 'include',
    headers: defaultHeaders,
  })
}

async function login({ username, password }) {
  const body = JSON.stringify({
    origin: 'DVP',
    username,
    password,
  })
  return await fetch(`${baseUrl}/login/sls/login1fa`, {
    method: 'POST',
    credentials: 'include',
    headers: defaultHeaders,
    body,
  })
}
